import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import Select from "react-select";
import * as XLSX from "xlsx";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  createSubCategories,
  deleteSubCategoriess,
  ExportSubCategoriesList,
  getSearchCategories,
  getSearchSubCategories,
  getSubCategoriesList,
  ImportSubCategoriesList,
  updateSubCategories,
} from "../../services/CategoriesServices";
import ReactPaginate from "react-paginate";

const SubCategories = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const { t } = useTranslation();
  const location = useLocation();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [wareHouseList, setWareHouseList] = useState([]);

  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [wareHouseEntityData, setWareHouseEntityData] = useState({
    id: "",
    uuid: "",
    categories_id: "",
    sub_category_name: "",
    parent_id: "",
  });

  let errorsObj = {
    sub_category_name: "",
    categories_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [CategoryList, setCategoryList] = useState([]);
  const [parentList, setParentList] = useState([]);

  const [modifyImportModal, setModifyImportModal] = useState(false);
  const [file, setFile] = useState(null);
  let errorsObjImport = {
    file: "",
  };
  const [errorsImport, setErrorsImport] = useState(errorsObjImport);
  const [partLocationDetails, setPartLocationDetails] = useState("");

  const [selectedEntityId, setSelectedEntityId] = useState("");

  const handleSelectChange = (event) => {
    const value = event.target.value;

    setSelectedEntityId(value);

    const findItemById = (nodes, id) => {
      for (let node of nodes) {
        if (node.id === id) return node;
        if (node.children) {
          const found = findItemById(node.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedItem = findItemById(parentList, value);
    setPartLocationDetails(selectedItem);
  };

  const handleImportModal = () => {
    setModifyImportModal(true);
  };

  const handleImportCloseModal = () => {
    setModifyImportModal(false);
    setErrorsImport("");
    setFile(null);
  };

  const handleAddModal = () => {
    setModifyModal(true);
    setSelectedEntityId("");
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setWareHouseEntityData("");
    setErrors({
      sub_category_name: "",
      categories_id: "",
    });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    setParams(paramsObj);
  };

  useEffect(function () {
    getSearchCategories()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCategoryList(list);
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setCategoryList([]);
      });
  }, []);

  useEffect(() => {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      id: 0,
    };
    getSearchSubCategories(data)
      .then((response) => {
        setParentList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  const fetchWareHouse = () => {
    let data = { ...params };
    getSubCategoriesList(data)
      .then((response) => {
        setWareHouseList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchWareHouse(data);
    },
    [params]
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onEditPartGroup = (e, item) => {
    setModifyModal(true);
    setWareHouseEntityData({
      id: item?.id,
      uuid: item?.uuid,
      categories_id: item?.categories_id,
      sub_category_name: item?.sub_category_name,
      parent_id: item?.parent_id,
    });
    setSelectedEntityId(item?.parent_id);
    setErrors({
      sub_category_name: "",
      categories_id: "",
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deleteSubCategoriess(data)
      .then((response) => {
        let data = { ...params };

        fetchWareHouse(data);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleWarehoueEntity = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };

    if (!wareHouseEntityData.sub_category_name) {
      errorObj.sub_category_name = `sub category name required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);
    let data = {
      sub_category_name: wareHouseEntityData.sub_category_name,
      categories_id: 0,
      parent_id: selectedEntityId,
    };

    let updateData = {
      uuid: wareHouseEntityData?.uuid,
      sub_category_name: wareHouseEntityData.sub_category_name,
      categories_id: 0,
      parent_id: selectedEntityId,
    };

    if (wareHouseEntityData?.uuid) {
      updateSubCategories(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchWareHouse(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWareHouseEntityData({
            id: "",
            uuid: "",
            categories_id: "",
            sub_category_name: "",
            parent_id: "",
          });
          setSelectedEntityId("");

          let datas = {
            limit: 10,
            page: 1,
            search: "",
            id: 0,
          };
          getSearchSubCategories(datas)
            .then((response) => {
              setParentList(response.data.data);
            })
            .catch((err) => {
              toast.error(err.message);
            });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createSubCategories(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchWareHouse(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWareHouseEntityData({
            id: "",
            uuid: "",
            categories_id: "",
            sub_category_name: "",
            parent_id: "",
          });
          setSelectedEntityId("");

          let datas = {
            limit: 10,
            page: 1,
            search: "",
            id: 0,
          };
          getSearchSubCategories(datas)
            .then((response) => {
              setParentList(response.data.data);
            })
            .catch((err) => {
              toast.error(err.message);
            });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  const handleImportGroup = (e) => {
    e.preventDefault();

    let error = false;
    let errorObjImport = { ...errorsObjImport };
    if (!file) {
      errorObjImport.file = `File is required.`;
      error = true;
    }

    setErrorsImport(errorObjImport);
    if (error) return;

    setIsModifyButtonLoad(true);
    const formData = new FormData();
    formData.append("files", file);

    ImportSubCategoriesList(formData)
      .then((response) => {
        toast.success(response.data.message);
        let data = { ...params };
        fetchWareHouse(data);
        setModifyImportModal(false);
        setIsModifyButtonLoad(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  const feacthCategoryList = () => {
    let data = { ...params };
    ExportSubCategoriesList(data)
      .then((response) => {
        const worksheet = XLSX.utils.json_to_sheet(response.data.data);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "subcategory.csv");
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleExport = () => {
    let data = { ...params };
    feacthCategoryList(data);
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => (
      <React.Fragment key={node.id}>
        <option
          value={node.id}
          style={{ fontWeight: node.children?.length ? "bold" : "normal" }}
        >
          {"\u00A0\u00A0".repeat(level) + node.sub_category_name}
        </option>
        {node.children?.length > 0 && renderOptions(node.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid ">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard container-custom-height">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>
                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleImportModal}
                        style={{ display: "none" }}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i>
                        <span className="ms-2">{t("import")}</span>
                      </button>

                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        style={{ display: "none" }}
                        onClick={handleExport}
                      >
                        <i className="bi bi-file-earmark-excel-fill"></i>
                        <span className="ms-2">{t("export")}</span>
                      </button>

                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleAddModal}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table table-striped table-hover">
                        <thead>
                          <tr>
                            {/* <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Category Name
                            </th> */}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Category Name
                            </th>

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {wareHouseList?.map((item, index) => {
                            return (
                              <>
                                <tr>
                                  {/* <td>{item?.category_name}</td> */}
                                  <td>
                                    <div>{item.sub_category_name}</div>
                                  </td>

                                  <td className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive"
                                            );
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "inherit !important";
                                            tableResponsive.style.overflowY =
                                              "inherit !important";
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onEditPartGroup(e, item)
                                          }
                                        >
                                          <div className="edit-btn">
                                            <i className="bi bi-pencil"></i>
                                          </div>

                                          <span>Edit</span>
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onDeleteModalOpen(e, item)
                                          }
                                        >
                                          <div className="trash-btn delete-btn">
                                            <i className="bi bi-trash3"></i>
                                          </div>

                                          <span>Delete</span>
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                        {wareHouseList && wareHouseList?.length === 0 && (
                          <tr>
                            <td colSpan={7} className={`text-center`}>
                              {" "}
                              {t("no_record_found")}
                            </td>
                          </tr>
                        )}
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer clearfix card-footer-part ">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Delete sub category`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to delete this sub category?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartType}
            >
              Delete <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>Sub Category</ModalHeader>
        <Form method={`post`} onSubmit={handleWarehoueEntity}>
          <ModalBody>
            <div className="row">
              <div className="col-md-12" style={{ display: "none" }}>
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Select Category"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        options={CategoryList}
                        value={CategoryList.find(
                          (option) =>
                            option.value ===
                            Number(wareHouseEntityData.categories_id)
                        )}
                        onChange={(selectedOption) =>
                          setWareHouseEntityData({
                            ...wareHouseEntityData,
                            categories_id: selectedOption.value,
                            category_name: selectedOption.label,
                          })
                        }
                        placeholder={"Select Category"}
                      />
                    </div>
                    {errors.categories_id && (
                      <span className="input-error">
                        {errors.categories_id}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseEntityData.sub_category_name}
                        onChange={(e) => {
                          setWareHouseEntityData({
                            ...wareHouseEntityData,
                            sub_category_name: e.target.value,
                          });
                        }}
                        name={`sub_category_name`}
                        maxLength={50}
                        placeholder="Name"
                      />
                    </div>
                    {errors.sub_category_name && (
                      <span className="input-error">
                        {errors.sub_category_name}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              {/* {parentList?.length > 0 && (
                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                      {"Parent Sub Category"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <Select
                          options={parentList}
                          value={parentList.find(
                            (option) =>
                              option.value ===
                              Number(wareHouseEntityData.parent_id)
                          )}
                          onChange={(selectedOption) =>
                            setWareHouseEntityData({
                              ...wareHouseEntityData,
                              parent_id: selectedOption.value,
                            })
                          }
                          placeholder={"Select"}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>
              )} */}

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Parent Sub-category"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <select
                        className="form-select"
                        value={selectedEntityId}
                        onChange={handleSelectChange}
                      >
                        <option>Select</option>
                        {renderOptions(parentList)}
                      </select>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                Submit <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyImportModal}>
        <Form method={`post`} onSubmit={handleImportGroup}>
          <ModalHeader>{"Import Sub Categories"}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label">{t("select_file")}</Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control"
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        name="file"
                        accept=".csv,.xlsx"
                      />
                    </div>
                    {errorsImport.file && (
                      <span className="input-error">{errorsImport.file}</span>
                    )}
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              disabled={isModifyButtonLoad}
              onClick={handleImportCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")}
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("import")}
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default SubCategories;
